

/* tslint:disable */



export enum ComponentCodeErrorCode {
    None = 0,
    NoWhitespaceAllowed = 1,
    SpecialCharacterNotAllowed = 2,
    InvalidPrefix = 3,

}


